/**
 * Comprehensive Mock Data System
 * Provides fallback data for all sections of the application when Sanity is unavailable
 */

// Mock Artworks - used in the Works page and floating artworks visualization
export const MOCK_ARTWORKS = [
  {
    _id: 'mock-artwork-1',
    title: 'Abstract Composition #3',
    artist: 'Emma Johnson',
    slug: 'abstract-composition-3',
    year: 2023,
    medium: 'Oil on Canvas',
    imageUrl: 'https://picsum.photos/seed/art1/800/600',
    artistImageUrl: 'https://picsum.photos/seed/artist1/100/100',
    price: 1200,
    edition: {
      size: 1,
      available: 1
    }
  },
  {
    _id: 'mock-artwork-2',
    title: 'Urban Landscape',
    artist: 'Michael Chen',
    slug: 'urban-landscape',
    year: 2022,
    medium: 'Digital Print',
    imageUrl: 'https://picsum.photos/seed/art2/800/600',
    artistImageUrl: 'https://picsum.photos/seed/artist2/100/100',
    price: 850,
    edition: {
      size: 10,
      available: 5
    }
  },
  {
    _id: 'mock-artwork-3',
    title: 'Serenity',
    artist: 'Olivia Williams',
    slug: 'serenity',
    year: 2023,
    medium: 'Mixed Media',
    imageUrl: 'https://picsum.photos/seed/art3/800/600',
    artistImageUrl: 'https://picsum.photos/seed/artist3/100/100',
    price: 1500,
    edition: {
      size: 1,
      available: 1
    }
  },
  {
    _id: 'mock-artwork-4',
    title: 'Fragments of Memory',
    artist: 'Daniel Lee',
    slug: 'fragments-of-memory',
    year: 2021,
    medium: 'Acrylic on Canvas',
    imageUrl: 'https://picsum.photos/seed/art4/800/600',
    artistImageUrl: 'https://picsum.photos/seed/artist4/100/100',
    price: 980,
    edition: {
      size: 1,
      available: 1
    }
  },
  {
    _id: 'mock-artwork-5',
    title: 'Geometric Study #7',
    artist: 'Sarah Parker',
    slug: 'geometric-study-7',
    year: 2023,
    medium: 'Digital',
    imageUrl: 'https://picsum.photos/seed/art5/800/600',
    artistImageUrl: 'https://picsum.photos/seed/artist5/100/100',
    price: 750,
    edition: {
      size: 15,
      available: 8
    }
  },
  {
    _id: 'mock-artwork-6',
    title: 'Ocean Memories',
    artist: 'James Wilson',
    slug: 'ocean-memories',
    year: 2022,
    medium: 'Watercolor',
    imageUrl: 'https://picsum.photos/seed/art6/800/600',
    artistImageUrl: 'https://picsum.photos/seed/artist6/100/100',
    price: 1100,
    edition: {
      size: 1,
      available: 0
    }
  },
  {
    _id: 'mock-artwork-7',
    title: 'City Nights',
    artist: 'Sophia Rodriguez',
    slug: 'city-nights',
    year: 2022,
    medium: 'Photography',
    imageUrl: 'https://picsum.photos/seed/art7/800/600',
    artistImageUrl: 'https://picsum.photos/seed/artist7/100/100',
    price: 890,
    edition: {
      size: 25,
      available: 18
    }
  },
  {
    _id: 'mock-artwork-8',
    title: 'Reflections',
    artist: 'David Miller',
    slug: 'reflections',
    year: 2023,
    medium: 'Oil on Canvas',
    imageUrl: 'https://picsum.photos/seed/art8/800/600',
    artistImageUrl: 'https://picsum.photos/seed/artist8/100/100',
    price: 1350,
    edition: {
      size: 1,
      available: 1
    }
  },
  {
    _id: 'mock-artwork-9',
    title: 'Untitled #12',
    artist: 'Emma Johnson',
    slug: 'untitled-12',
    year: 2023,
    medium: 'Mixed Media',
    imageUrl: 'https://picsum.photos/seed/art9/800/600',
    artistImageUrl: 'https://picsum.photos/seed/artist1/100/100',
    price: 950,
    edition: {
      size: 1,
      available: 1
    }
  }
];

// Mock Artists - used in the Artists page
export const MOCK_ARTISTS = [
  {
    _id: 'mock-artist-1',
    name: 'Emma Johnson',
    slug: 'emma-johnson',
    bio: 'Emma Johnson is a contemporary artist known for her abstract compositions that explore the relationship between color and emotion.',
    profileImageUrl: 'https://picsum.photos/seed/artist1/300/300',
    artworks: [MOCK_ARTWORKS[0], MOCK_ARTWORKS[8]]
  },
  {
    _id: 'mock-artist-2',
    name: 'Michael Chen',
    slug: 'michael-chen',
    bio: 'Michael Chen is a digital artist whose work examines urban landscapes and the impact of technology on modern life.',
    profileImageUrl: 'https://picsum.photos/seed/artist2/300/300',
    artworks: [MOCK_ARTWORKS[1]]
  },
  {
    _id: 'mock-artist-3',
    name: 'Olivia Williams',
    slug: 'olivia-williams',
    bio: 'Olivia Williams creates mixed media artworks that explore themes of nature, memory, and personal identity.',
    profileImageUrl: 'https://picsum.photos/seed/artist3/300/300',
    artworks: [MOCK_ARTWORKS[2]]
  },
  {
    _id: 'mock-artist-4',
    name: 'Daniel Lee',
    slug: 'daniel-lee',
    bio: 'Daniel Lee is an experimental painter whose work blends traditional techniques with contemporary subjects.',
    profileImageUrl: 'https://picsum.photos/seed/artist4/300/300',
    artworks: [MOCK_ARTWORKS[3]]
  },
  {
    _id: 'mock-artist-5',
    name: 'Sarah Parker',
    slug: 'sarah-parker',
    bio: 'Sarah Parker is a digital artist specializing in geometric compositions that explore mathematical principles through visual art.',
    profileImageUrl: 'https://picsum.photos/seed/artist5/300/300',
    artworks: [MOCK_ARTWORKS[4]]
  }
];

// Mock Events - used in the Programme page
export const MOCK_EVENTS = [
  {
    _id: 'mock-event-1',
    title: 'Summer Exhibition: New Perspectives',
    eventType: 'Exhibition',
    description: 'A group exhibition featuring new works by our represented artists, exploring themes of perspective and perception.',
    startDate: '2025-06-15T10:00:00Z',
    endDate: '2025-07-30T18:00:00Z',
    openingReception: '2025-06-15T18:00:00Z',
    closingReception: null,
    galleryHours: 'Tuesday-Saturday, 10am-6pm',
    venue: 'Substans Gallery',
    venueAddress: '123 Art Street, City',
    slug: 'summer-exhibition-new-perspectives',
    bannerImageUrl: 'https://picsum.photos/seed/event1/1200/600',
    organizers: [
      { name: 'Substans Art', role: 'Host', profileImageUrl: 'https://picsum.photos/seed/org1/100/100' }
    ],
    featuredArtworks: [MOCK_ARTWORKS[0], MOCK_ARTWORKS[2], MOCK_ARTWORKS[4]]
  },
  {
    _id: 'mock-event-2',
    title: 'Artist Talk: Emma Johnson',
    eventType: 'Talk',
    description: 'Join artist Emma Johnson as she discusses her creative process and the inspiration behind her latest series of works.',
    startDate: '2025-06-20T18:30:00Z',
    endDate: '2025-06-20T20:00:00Z',
    openingReception: null,
    closingReception: null,
    galleryHours: null,
    venue: 'Substans Gallery',
    venueAddress: '123 Art Street, City',
    slug: 'artist-talk-emma-johnson',
    bannerImageUrl: 'https://picsum.photos/seed/event2/1200/600',
    organizers: [
      { name: 'Substans Art', role: 'Host', profileImageUrl: 'https://picsum.photos/seed/org1/100/100' },
      { name: 'Emma Johnson', role: 'Speaker', profileImageUrl: 'https://picsum.photos/seed/artist1/100/100' }
    ],
    featuredArtworks: [MOCK_ARTWORKS[0], MOCK_ARTWORKS[8]]
  },
  {
    _id: 'mock-event-3',
    title: 'Workshop: Digital Art Fundamentals',
    eventType: 'Workshop',
    description: 'A hands-on workshop led by Michael Chen, exploring the fundamentals of digital art creation using industry-standard tools.',
    startDate: '2025-07-10T14:00:00Z',
    endDate: '2025-07-10T17:00:00Z',
    openingReception: null,
    closingReception: null,
    galleryHours: null,
    venue: 'Digital Arts Center',
    venueAddress: '456 Tech Boulevard, City',
    slug: 'workshop-digital-art-fundamentals',
    bannerImageUrl: 'https://picsum.photos/seed/event3/1200/600',
    organizers: [
      { name: 'Substans Art', role: 'Organizer', profileImageUrl: 'https://picsum.photos/seed/org1/100/100' },
      { name: 'Michael Chen', role: 'Instructor', profileImageUrl: 'https://picsum.photos/seed/artist2/100/100' }
    ],
    featuredArtworks: [MOCK_ARTWORKS[1]]
  }
];

// Mock Blog Posts - used in the Journal page
export const MOCK_BLOG_POSTS = [
  {
    _id: 'mock-blog-1',
    title: 'The Evolution of Abstract Art in the 21st Century',
    slug: 'evolution-abstract-art-21st-century',
    postType: 'Article',
    publishedDate: '2025-05-10T09:00:00Z',
    author: 'Art Historian',
    authorImageUrl: 'https://picsum.photos/seed/author1/100/100',
    contentPreview: 'Abstract art has undergone significant transformations in the 21st century, influenced by digital technologies, global connectivity, and changing perspectives on representation...',
    featuredImageUrl: 'https://picsum.photos/seed/blog1/1200/600',
    tags: ['Abstract Art', 'Contemporary Art', 'Art History']
  },
  {
    _id: 'mock-blog-2',
    title: 'Artist Spotlight: Emma Johnson',
    slug: 'artist-spotlight-emma-johnson',
    postType: 'Interview',
    publishedDate: '2025-05-05T14:30:00Z',
    author: 'Gallery Curator',
    authorImageUrl: 'https://picsum.photos/seed/author2/100/100',
    contentPreview: 'In this exclusive interview, we speak with Emma Johnson about her creative journey, her latest series "Abstract Compositions," and her unique approach to color and form...',
    featuredImageUrl: 'https://picsum.photos/seed/blog2/1200/600',
    tags: ['Artist Interview', 'Emma Johnson', 'Contemporary Artists']
  },
  {
    _id: 'mock-blog-3',
    title: 'Collecting Art: A Guide for New Collectors',
    slug: 'collecting-art-guide-new-collectors',
    postType: 'Guide',
    publishedDate: '2025-04-28T11:15:00Z',
    author: 'Art Advisor',
    authorImageUrl: 'https://picsum.photos/seed/author3/100/100',
    contentPreview: 'Starting an art collection can be both exciting and overwhelming. This guide offers practical advice for new collectors, from understanding the art market to making your first purchase...',
    featuredImageUrl: 'https://picsum.photos/seed/blog3/1200/600',
    tags: ['Art Collecting', 'Art Market', 'Investment']
  },
  {
    _id: 'mock-blog-4',
    title: 'Upcoming Exhibitions: Summer 2025',
    slug: 'upcoming-exhibitions-summer-2025',
    postType: 'News',
    publishedDate: '2025-04-15T16:45:00Z',
    author: 'Gallery Director',
    authorImageUrl: 'https://picsum.photos/seed/author4/100/100',
    contentPreview: 'Discover the exciting exhibitions coming to Substans Art this summer, featuring both established artists and emerging talents from around the world...',
    featuredImageUrl: 'https://picsum.photos/seed/blog4/1200/600',
    tags: ['Exhibitions', 'Gallery News', 'Summer 2025']
  }
];

// Function to get mock data based on query
export function getMockData(query: string): any {
  // Simple pattern matching to return appropriate mock data
  if (query.includes('artwork')) {
    return MOCK_ARTWORKS;
  } else if (query.includes('artist')) {
    return MOCK_ARTISTS;
  } else if (query.includes('event')) {
    return MOCK_EVENTS;
  } else if (query.includes('blogPost')) {
    return MOCK_BLOG_POSTS;
  }
  
  // Default to artworks if no match
  return MOCK_ARTWORKS;
}
